import { useCallback } from "react";
import { useSearchParams } from "react-router";

// Appended by the wealthAPI-hosted TPP web-form when it redirects back to the app
export const useBankImportParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const bankConnectionId = Number(searchParams.get("bankConnectionId"));
  const bankConnectionType = searchParams.get("bankConnectionType");
  const flow = searchParams.get("flow");
  const isEarlyRedirect = searchParams.get("isEarlyRedirect") === "true";

  const clearParams = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete("bankConnectionId");
      prev.delete("bankConnectionType");
      prev.delete("flow");
      prev.delete("isEarlyRedirect");
      return prev;
    });
  }, [setSearchParams]);

  return {
    bankConnectionId: bankConnectionId > 0 ? bankConnectionId : null,
    bankConnectionType,
    flow,
    isEarlyRedirect,
    clearParams,
  };
};
